import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Alert, Button, Loader, Table } from '@itds/elements/index.js';
import { Colors } from '@itds/Theme';

import EditAdDrawer from './ads/Edit';

import { Api } from '@brokerage/utils/Api';

const AdsList = ({ mobile_app }) => {
  const [ad_campaigns, setAdCampaigns] = useState([]);
  const [loading, setLoading] = useState(false);
  const [ad, setAd] = useState(null);
  const [error_message, setErrorMessage] = useState();
  const [success_message, setSuccessMessage] = useState();

  useEffect(() => {
    loadAdCampaigns();
  }, []);

  const loadAdCampaigns = () => {
    setLoading(true);

    Api.loadAgencyMobileAppAdCampaigns(mobile_app.guid).then(({ data }) => {
      setAdCampaigns(data);
      setLoading(false);
    });
  };

  const handleDelete = (ad_campaign_id, e) => {
    e.stopPropagation();

    window.scrollTo(0, 0);

    setTimeout(() => {
      setErrorMessage(null);
      setSuccessMessage(null);
    }, 2000);

    setLoading(true);

    Api.deleteAgencyMobileAppAdCampaign(ad_campaign_id)
      .then(() => {
        loadAdCampaigns();
        setLoading(false);
        setSuccessMessage('Ad Campaign deleted');
      })
      .catch(() => {
        setLoading(false);
        setSuccessMessage('Unable to delete the Ad Campaign at this time');
      });
  };

  const handleSave = response => {
    setAd(null);
    loadAdCampaigns();

    setTimeout(() => {
      setErrorMessage(null);
      setSuccessMessage(null);
    }, 2000);

    return response === 'success'
      ? setSuccessMessage('Ad Campaign updated successfully')
      : setErrorMessage('Unable to update Ad Campaign');
  };

  return loading ? (
    <Loader />
  ) : (
    <>
      <EditAdDrawer
        ad={ad}
        mobile_app={mobile_app}
        onClose={setAd.bind(null, null)}
        onSave={handleSave}
        show={!!ad}
      />

      <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: 30 }}>
        <Button onClick={setAd.bind(null, {})}>New Ad Campaign</Button>
      </div>

      {error_message ? <Alert type='error'>{error_message}</Alert> : null}
      {success_message ? <Alert type='success'>{success_message}</Alert> : null}

      <Table
        columns={[
          {
            id: 'name',
            label: 'Name'
          },
          {
            id: 'guid',
            label: 'GUID'
          },
          {
            id: 'active',
            label: 'Active',
            width: 100,
            render: ad =>
              ad.is_active ? (
                <i
                  className='mdi mdi-check-bold'
                  style={{ color: Colors.GREEN.hex, fontSize: 20 }}
                />
              ) : null
          },
          {
            id: 'actions',
            render: ad => {
              return (
                <Button
                  color='RED'
                  inline={true}
                  onClick={handleDelete.bind(null, ad.id)}
                  small={true}
                >
                  Delete
                </Button>
              );
            },
            styles: { textAlign: 'right' }
          }
        ]}
        data={ad_campaigns}
        onRowClick={ad => setAd(ad)}
        placeholder='No Ad Campaigns Yet'
      />
    </>
  );
};

AdsList.propTypes = {
  mobile_app: PropTypes.object
};

export default AdsList;
